import { StyleSheet } from 'aphrodite';

export const behaviorCaseNodeStyles = StyleSheet.create({
	card: {
		backgroundColor: '#FFFFFF',
		border: '4px solid #003C84',
		borderRadius: 12,
		boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.08)',
		minWidth: 280,
		maxWidth: 560,
		position: 'relative' as const,
	},
	cardSelected: {
		boxShadow: '0 0 0 2px #2E67ED, 0px 4px 4px rgba(0, 0, 0, 0.08)',
	},
	cardPath: {
		boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.18), 0px 4px 4px rgba(0, 0, 0, 0.08)',
	},
	cardTarget: {
		boxShadow: '0 0 0 4px rgba(220, 38, 38, 0.18), 0px 4px 4px rgba(0, 0, 0, 0.08)',
	},
	connectionDot: {
		width: 16,
		height: 16,
		background: '#2E67ED',
		border: '2px solid #FFFFFF',
		borderRadius: '50%',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '14px 16px 10px',
		gap: 12,
	},
	headerLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		flex: 1,
		minWidth: 0,
	},
	headerActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		flexShrink: 0,
	},
	iconCircle: {
		width: 42,
		height: 42,
		borderRadius: '50%',
		backgroundColor: '#003C84',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
	},
	title: {
		fontFamily: "'Sora', sans-serif",
		fontWeight: 600,
		fontSize: 18,
		lineHeight: '24px',
		color: '#0D0F11',
		margin: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	compactInner: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px 16px',
		cursor: 'pointer',
		gap: 12,
	},
	compactTitle: {
		fontFamily: "'Sora', sans-serif",
		fontWeight: 600,
		fontSize: 16,
		color: '#0D0F11',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	iconButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 28,
		height: 28,
		border: 'none',
		backgroundColor: 'transparent',
		cursor: 'pointer',
		padding: 0,
		borderRadius: 4,
		':hover': {
			backgroundColor: '#F3F4F6',
		},
	},
	divider: {
		height: 1,
		backgroundColor: '#C6CCD7',
		margin: '0 16px',
	},
	content: {
		padding: '10px 16px 14px',
	},
	defaultSubtitle: {
		fontSize: 13,
		color: '#6B7280',
		margin: '0 0 6px',
		lineHeight: '18px',
	},
});
